type JobRoleEnum =
	| 'Laborer'
	| 'Foreman'
	| 'GeneralForeman'
	| 'Superintendent'
	| 'ProjectControls'
	| 'SuperAdmin'
	| 'LineTech'
	| 'LineTechManager'
	| 'Tracker'
	| 'QualityControl'
	| 'QualityControlManager'
	| 'MaterialManager'
	| 'Material'
	| 'OfficeAdmin'
type JobRole = {
	id?: number
	hierarchyIndex: number
	title: JobRoleEnum
}

type JobRoleSource = {
	[K in JobRoleEnum]: string
}

const JobRoleTitles: JobRoleSource = {
	Laborer: 'Laborer',
	Foreman: 'Foreman',
	GeneralForeman: 'General Foreman',
	Superintendent: 'Superintendent',
	ProjectControls: 'PCM',
	SuperAdmin: 'Super Admin',
	LineTech: 'Line Tech',
	LineTechManager: 'Line Tech Manager',
	Tracker: 'Tracker',
	QualityControl: 'Quality Control',
	QualityControlManager: 'Quality Control Manager',
	MaterialManager: 'Material Manager',
	Material: 'Material',
	OfficeAdmin: 'Office Admin',
}

export type { JobRoleEnum, JobRole }
export { JobRoleTitles }
